/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Import_CompleteInputs */



/**
* | output |
* | --- |
* | "Import Complete." |
*
* @param {Ateliere_Connect_Status_Import_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_import_complete = /** @type {((inputs?: Ateliere_Connect_Status_Import_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Import_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation terminée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione completata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación completada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポートが完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात पूर्ण हुआ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação concluída.")
	return /** @type {LocalizedString} */ ("Import Complete.")
});